import { useQuery } from 'react-query';

import { useCountriesReferentialState } from '@/features/shared/hooks/useCountriesReferential.state';
import { axios } from '@/lib/axios';

type country = Record<string, string>;

export type GetCountriesResponse = {
  countries: country[];
};

const getCountriesAsync = () => axios.get<country>(`/country-code-referential`);

export const useGetCountriesAsync = () =>
  useQuery({
    queryKey: ['countries'],
    queryFn: async () => {
      const { data } = await getCountriesAsync();
      return data;
    },
    onSuccess: (data) => {
      useCountriesReferentialState.setState({ countriesReferential: data });
    },
  });
